// removed by extract-text-webpack-plugin
module.exports = {"container":"App__container___1YSRW"};